/*
 * @Author: Dong
 * @Date: 2021-05-08 15:33:46
 * @LastEditors: Dong
 * @LastEditTime: 2021-09-14 13:46:03
 */
import '@babel/polyfill';
import React, { useState } from 'react';
import { LocaleProvider } from 'sup-ui';
import { IntlProvider } from 'react-intl';
import {
  HashRouter as Router,
  Switch,
  Route,
  Redirect
} from 'react-router-dom';
import { local, componentlocal } from './language';
import LanguageContext from './utils/LanguageContext';
import routes from './router';

// 设置默认语言
if (!localStorage.getItem('language')) {
  localStorage.setItem('language', 'zh-cn');
  localStorage.setItem('languageName', '简体中文');
}

function RouteWithSubRoutes(route) {
  return (
    <Route
      path={route.path}
      render={(props) => (
        <route.component
          {...props}
          routes={route.routes}
          store={route.store}
          RouteWithSubRoutes={RouteWithSubRoutes}
        />
      )}
    />
  );
}

function App() {
  // 多语言切换
  const [language, setLanguage] = useState(window.localStorage.getItem('language') || 'zh-cn');
  const getLanguage = local.filter((e) => e.locale === (window.localStorage.getItem('language') || 'zh-cn'))[0];
  const getLocaleLanguage = componentlocal[window.localStorage.getItem('language') || 'zh-cn'];

  return (
    <LanguageContext.Provider
      value={{
        language,
        setLanguage
      }}
    >
      <IntlProvider {...getLanguage} defaultLocale="zh-cn">
        <LocaleProvider locale={getLocaleLanguage}>
          <Router>
            <Switch>
              <Route exact path="/">
                <Redirect to="/login" />
              </Route>
              {routes.map((route, i) => (
                <RouteWithSubRoutes key={`route_${i + 1}`} {...route} />
              ))}
            </Switch>
          </Router>
        </LocaleProvider>
      </IntlProvider>
    </LanguageContext.Provider>
  );
}

export default App;
